// The scope of this file is for global components
// All the components that are globally accessible will be added here.

import Accordian from '@/components/Common/Accordian.vue';
import Tabs from '@/components/Common/Tabs.vue';
import Container from '@/components/Common/Container.vue';
import Button from '@/components/Common/FilledButton.vue';
import RecursiveTree from '@/components/Common/RecursiveTree.vue';
import InputTextTag from '@/components/Common/InputTextTag.vue';
import Table from '@/components/Common/Table.vue';
import Dialog from '@/components/Common/Dialog.vue';
import OrgPageHeading from '@/components/Organisations/OrgPageHeading.vue';
import Checkbox from '@/components/Common/Checkbox.vue';
import Loader from '@/components/Common/FullWidthLoader.vue';
import SearchBar from '@/components/Organisations/Domains/SearchBar.vue';
import Avatar from '@/components/Common/Avatar';
import SelectBox from '@/components/Common/SelectBox';
// Adding global components and giving them names
// We can use these names to access these components
// @example x-accordian(common name) for Accordian (component)

const GlobalComponents = {
  install(Vue) {
    Vue.component('x-accordian', Accordian);
    Vue.component('x-tabs', Tabs);
    Vue.component('x-container', Container);
    Vue.component('x-button', Button);
    Vue.component('x-dialog', Dialog);
    Vue.component('recursive-tree', RecursiveTree);
    Vue.component('tag', InputTextTag);
    Vue.component('x-table', Table);
    Vue.component('x-org-heading', OrgPageHeading);
    Vue.component('checkbox', Checkbox);
    Vue.component('loader', Loader);
    Vue.component('search-bar', SearchBar);
    Vue.component('x-avatar', Avatar);
    Vue.component('x-select', SelectBox);
  }
};

export default GlobalComponents;
